import dayjs from "dayjs";
import { CoreContext, RBButton, RbIconButton } from "@scmlatam/web-ui";
import { useContext } from "react";
import ReportStatusCompleteIcon from "../../../../assets/icons/report-status-complete-icon.svg";
import ReportStatusExecutingIcon from "../../../../assets/icons/report-status-executing-icon.svg";
import ReportStatusCompletedWithErrorsIcon from "../../../../assets/icons/report-status-complete-with-error-icon.svg";
import ReportStatusFailedIcon from "../../../../assets/icons/report-status-failed-icon.svg";
import ReportUndoExecutingIcon from "../../../../assets/icons/report-undo-executing-icon.svg";
import ReportFormatCsvDownload from "../../../../assets/icons/report-format-csv-download-icon.svg";
import ReportFormatPdfDownload from "../../../../assets/icons/report-format-pdf-download-icon.svg";
import ReportFormatDocDownload from "../../../../assets/icons/report-format-doc-download-icon.svg";
import ReportFormatWebViewIcon from "../../../../assets/icons/report-format-web-view-icon.svg";
import type { CellProps } from "../types/component";

const Cell = ({ t, row, column, canDeleteResult = false, setOpen, setRowId }: CellProps) => {
  const { format } = useContext(CoreContext);

  const getImgStatus = (status: string) => {
    switch (status) {
      case "Complete":
        return ReportStatusCompleteIcon;
      case "Executing":
        return ReportStatusExecutingIcon;
      case "Completed_with_errors":
        return ReportStatusCompletedWithErrorsIcon;
      case "Failed":
        return ReportStatusFailedIcon;
      default:
        return "";
    }
  };

  switch (column) {
    case "created_at":
      return (
        <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
          <span
            style={{
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "normal",
            }}
          >
            {dayjs(row.created_at).format(format)}
          </span>

          <span
            style={{
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "normal",
            }}
          >
            {dayjs(row.created_at).format("HH:mm:ss")}
          </span>
        </div>
      );
    case "finished_at":
      return (
        <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
          <span
            style={{
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "normal",
            }}
          >
            {dayjs(row.finished_at).format(format)}
          </span>

          <span
            style={{
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "normal",
            }}
          >
            {dayjs(row.finished_at).format("HH:mm:ss")}
          </span>
        </div>
      );
    case "state":
      return (
        <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <img
              src={getImgStatus(row.state)}
              alt={row.state}
              style={{ width: "12px", height: "12px" }}
            />
            {t(`columns.state.values.${row.state}`)}
          </span>
        </div>
      );
    case "format":
      if (row.state === "Executing") {
        if (!canDeleteResult) return null;

        return (
          <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
            <RBButton
              variant="secondary"
              rightIcon={
                <img
                  src={ReportUndoExecutingIcon}
                  alt="report-undo-executing-icon"
                />
              }
              onClick={() => {
                if (setOpen && setRowId) {
                  setOpen(true);
                  setRowId(row.id);
                }
              }}
              size="s"
            >
              {t("buttons.undo")}
            </RBButton>
          </div>
        );
      } else {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <RbIconButton
              size="s"
              aria-label="report-format-table-view-icon"
              onClick={() => {
                window.open(row.format.xlsUrl, "_blank");
              }}
            >
              <img
                src={ReportFormatCsvDownload}
                alt="report-format-csv-download-icon"
                style={{ width: "20px", height: "20px" }}
              />
            </RbIconButton>

            <RbIconButton
              size="s"
              aria-label="report-format-pdf-download-icon"
              onClick={() => {
                window.open(row.format.pdfUrl, "_blank");
              }}
            >
              <img
                src={ReportFormatPdfDownload}
                alt="report-format-pdf-download-icon"
                style={{ width: "20px", height: "20px" }}
              />
            </RbIconButton>

            <RbIconButton
              size="s"
              aria-label="report-format-doc-download-icon"
              onClick={() => {
                window.open(row.format.docUrl, "_blank");
              }}
            >
              <img
                src={ReportFormatDocDownload}
                alt="report-format-doc-download-icon"
                style={{ width: "20px", height: "20px" }}
              />
            </RbIconButton>

            <RbIconButton
              size="s"
              aria-label="report-format-web-view-icon"
              onClick={() => {
                window.open(row.format.htmlUrl, "_blank");
              }}
            >
              <img
                src={ReportFormatWebViewIcon}
                alt="report-format-web-view-icon"
                style={{ width: "20px", height: "20px" }}
              />
            </RbIconButton>
          </div>
        );
      }
    default:
      return <>custom cell</>;
  }
};

export { Cell };
